import React, { useEffect } from 'react';
import {
    Box,
    Container,
    Typography,
} from "@mui/material";
import { useLocation, useNavigate } from 'react-router-dom';
import { paths } from '../../../../utils/path';

const StatewiseStatsTable = () => {
    const navigate = useNavigate();
    const location = useLocation();

    // Get data from location state
    const { type, stateWiseData } = location.state || {};

    // Type configuration mapping
    const typeConfig = {
        tccc: {
            title: "TCCC State-Wise Statistics",
            columnHeader: "Total TCCC",
            dataKey: "total_mi"
        },
        dccc: {
            title: "DCCC State-Wise Statistics",
            columnHeader: "Total DCCC",
            dataKey: "total_dccc"
        },
        beneficiaries: {
            title: "Beneficiaries State-Wise Statistics",
            columnHeader: "Total Beneficiaries",
            dataKey: "total_patients"
        },
        chemo: {
            title: "Chemo Sessions State-Wise Statistics",
            columnHeader: "Total Chemo Sessions",
            dataKey: "total_chemo"
        }
    };

    useEffect(() => {
        // Redirect to dashboard if type or data is missing/invalid
        if (!type || !typeConfig[type]) {
            navigate(`${paths?.user?.commonPoint}${paths?.user?.adminDashboard}`);
        }
    }, [type, navigate]);

    // Get current configuration based on type
    const config = type && typeConfig[type] ? typeConfig[type] : null;

    // Don't render if no valid type or data
    if (!config || !stateWiseData) {
        return null;
    }

    return (
        <>
            <Box
                sx={{
                    width: "100%",
                    backgroundColor: "#FFFFFF",
                    borderBottom: "1px solid #E6E6E6", // light grey line
                    py: 2,
                }}
            >
                <Container>
                    {/* Title */}
                    <Typography variant="h6" fontWeight="600">
                        Day Care Cancer Center
                    </Typography>

                    {/* Subtitle */}
                    <Typography variant="body2" color="gray" sx={{ mt: 0.3 }}>
                        National Cancer Care Program - Comprehensive Overview
                    </Typography>
                </Container>
            </Box>

            <Container>
                <Typography variant="h6" fontWeight={600} className="mt-3">
                    {config?.title}
                </Typography>

                {/* Table Section */}
                <div className=" shadow table-design my-3">
                    <div className="table-responsive mt-2">
                        <table className="table align-middle mb-0 custom-table">
                            <thead>
                                <tr>
                                    <th>S.No.</th>
                                    <th>States</th>
                                    <th>{config?.columnHeader}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {stateWiseData && stateWiseData.length > 0 ? (
                                    stateWiseData.map((state, index) => (
                                        <tr key={state?.state_lgd || index}>
                                            <td>{index + 1}</td>
                                            <td>{state?.state_name || "N/A"}</td>
                                            <td>{state?.[config?.dataKey] || "0"}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="2" className="text-center">
                                            No data available
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </Container>
        </>
    )
}

export default StatewiseStatsTable